
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tooling/[slug]",
      function () {
        return require("private-next-pages/tooling/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tooling/[slug]"])
      });
    }
  